// import styles from './SecondaryAdBanner.module.css';
import { useContext, useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import VideoContext from "../../store/video-context";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import countryList from "react-select-country-list";
import "react-phone-number-input/style.css";
import AdPopup from "../AdPopup/AdPopup";
import ReactGA from 'react-ga';

const PrimaryAdBanner = (props: any) => {
  const options = useMemo(() => countryList().getData(), []);
  const vContext = useContext(VideoContext);
  const [adData, setAdData] = useState(props.data[0]);
  const [show, setShow] = useState(false);

  const [timePlaceholder, setTimePlaceholder] = useState("What is a good time to call you?");
  const [timePlaceholderError, setTimePlaceholderError] = useState("Please provide a valid time.");
  let test = 0;
  let ads_loaded = 0;
  const updateAd = () => {
  if (test >= props.data.length - 1) {
    test = 0;
  } else {
    test++;
  }

  setAdData(props.data[test]);
  
  //alert(test);
    if(props.data[test].product_name)
    {
    if((props.data[test].product_name.toLowerCase().includes("mot")== true || props.data[test].product_name.toLowerCase().includes("skilllabtalktoexpert")== true) && ads_loaded==0)
    {
      ReactGA.event({
        category: 'Player Page',
        action: "Ad loaded",
        label: props.data[test].product_name
      });
    }
  }
    if(test == props.data.length - 1)
    ads_loaded =1;
  };
  useEffect(() => {
    
    if(props.data[test].product_name)
    {
      if((props.data[test].product_name.toLowerCase().includes("mot")== true || props.data[test].product_name.toLowerCase().includes("skilllabtalktoexpert")== true) && ads_loaded==0)
    {
    
      ReactGA.event({
        category: 'Player Page',
        action: "Ad loaded",
        label: props.data[test].product_name
      });
    }
  }
  setInterval(() => updateAd(), 10000);
  }, []);

  const openAdModal = (advData: any) => {
    vContext.setEnquiryProductHandler(advData)
    vContext.setIsInstrumentEnquiryHandler(false);
    setShow(true);
    //alert(advData.product_name);
    if(advData.product_name == "HB-ESU-Service-Ad")
    {
    setTimePlaceholder("product details and problem faced"); 
    setTimePlaceholderError("Please provide product details and problem faced");
    }

    // if (advData.link !== undefined && advData.link !== "") {
    //   window.open("" + advData.link, "_blank");
    // }
    //alert(advData.popup);
    if(advData.popup == "no"){
      if (advData.link !== undefined && advData.link !== "") {
        setShow(false);
        window.open("" + advData.link, "_blank");
      }
    }

    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveProductEnquiry&transID=" +
        vContext.transId +
        "&userID=" +
        vContext.userId +
        "&productName=" +
        advData.product_name +
        "&confirm=0"+
        "&time="+
        null
    )
      .then((res) => res.json())
      .catch((error) => {
        console.error("Error:(clickedOnAd)", error);
      });
  };

  const closeAdModal = () => {
    setShow(false);
  };


  return (
    <>
      {!isEmpty(adData) && (
        <>
          <div id="primaryAd"
            className="right-ad blue-shadow-box d-flex align-items-center justify-content-center mb-3"
            style={{ cursor: adData.click === "yes" ? "pointer" : "default" }}
            onClick={() =>{
              console.log("click",adData.click);
              if(adData.click == "yes"){ show ? setShow(false) : openAdModal(adData)}}}
          >
            {/* <h2 className="text-uppercase mb-0"> */}
            {adData.image_path.toLowerCase().includes("mp4")== false  && (
              <img
                src={"../" + adData.image_path}
                alt={adData.product_name}
                className="img-fluid w-100"
                onLoad={()=>{
                  console.log("load")
                  //document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - document.getElementById("primaryAd")!.clientHeight - 45) + "px";
                  var notif_div = document.getElementById("notif-div");     
        if(notif_div){
            //#myElementID element DOES exists
           //document.getElementById("conversation")!.style.height = document.getElementById("conversation")!.clientHeight - document.getElementById("notif-div")!.clientHeight+"px";
           var primaryAd = document.getElementById("primaryAd");  
           if(primaryAd){  
             document.getElementById("conversation")!.style.height = (window.innerHeight - 54-10 - document.getElementById("primaryAd")!.clientHeight -document.getElementById("notif-div")!.clientHeight- 45) + "px";
           } else {
             document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - 25-document.getElementById("notif-div")!.clientHeight) + "px";
           }
        }
        else{
          var primaryAd = document.getElementById("primaryAd");  
          if(primaryAd){  
            document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - document.getElementById("primaryAd")!.clientHeight - 45) + "px";
          } else {
            document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - 25) + "px";
          }
        }


                }}
              />
            )}
            {/* </h2> */}
          </div>
          <div>
           <Modal show={show} onHide={closeAdModal}>
           <AdPopup timePlaceholder={timePlaceholder} timePlaceholderError={timePlaceholderError} oncloseEvent={closeAdModal} />
            </Modal>
          </div>
        </>
      )}
    </>
  );
};

export default PrimaryAdBanner;
